import * as THREE from 'three'
import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler.js'
import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper.js'

import EventEmitter from "./utils/EventEmitter"
import Experience from "./Experience"

export default class ObjectsLoader extends EventEmitter
{
    constructor()
    {
        super()

        this.experience = new Experience()
        this.resources = this.experience.resources
        this.resources.on("ready", () => {this.init()})

        this.items = {}

        this.numberOfElements = 0
    }

    init()
    {
        this.createModels()
        
        this.createRandomPoints()

        this.trigger('ready')
    }

    createModels()
    {
        this.object_0 = this.createGroup(this.resources.items.Object_0.scene.children[0].clone(), "Object_0")

        this.object_1 = this.createGroup(this.resources.items.Object_1.scene.children[0].clone(), "Object_1")

        this.object_2 = this.createGroup(this.resources.items.Object_2.scene.children[0].clone(), "Object_2")

        this.object_3 = this.createGroup(this.resources.items.Object_3.scene.children[0].clone(), "Object_3")

        this.molecule = this.resources.items.Object_3.scene.children[1].clone()
        this.molecule.scale.set(0.0, 0.0, 0.0)
        this.molecule.material = new THREE.MeshBasicMaterial
        (
            {
                color: 0xAAFF20,
                transparent: true,
                opacity: 0.0,
                depthWrite: false                
            }
        )
        this.experience.scene.add(this.molecule)
        this.items["Molecule"] = this.molecule

        this.panel = this.createGroup(new THREE.Mesh(new THREE.PlaneGeometry(10.0, 30.0)), "Plane")
    }

    createRandomPoints()
    {
        this.randomPoints = []

        let distance = 5.0

        for (let i = 0; i < this.numberOfElements; i++)
        {
            let randomX = (Math.random() * distance) * (Math.random() < 0.5 ? 1.0 : - 1.0)
            let randomY = (Math.random() * distance) * (Math.random() < 0.5 ? 1.0 : - 1.0)
            let randomZ = 0.5 // (Math.random() * (distance - 1.0)) * -1.0 - 1.0
            
            this.randomPoints.push(new THREE.Vector3(randomX, randomY, randomZ))
        }

        this.randomPoints = this.sortArray(this.randomPoints, 1)
    }

    createGroup(mesh, name)
    {
        let newMesh = mesh
        mesh.name = name
        mesh.material = new THREE.MeshBasicMaterial
        (
            {
                color: new THREE.Color(1.0, 1.0, 1.0),
                transparent: true,
                opacity: 0.0,
                depthWrite: false,
                wireframe: true
            }
        )
        this.experience.scene.add(mesh)

        let currentGeometry = mesh.geometry.clone()
        let vertexLinear = currentGeometry.getAttribute("position").array;    
        let normalsLinear = currentGeometry.getAttribute("normal").array;
        let vertexUnfiltered = []
        let normalsUnfiltered = []

        for (let i = 0; i < vertexLinear.length / 3; i++)
        {
            let index = i * 3

            let tempVertex = new THREE.Vector3(vertexLinear[index], vertexLinear[index + 1], vertexLinear[index + 2])                
            vertexUnfiltered.push(tempVertex)

            let tempNormal = new THREE.Vector3(normalsLinear[index], normalsLinear[index + 1], normalsLinear[index + 2])
            normalsUnfiltered.push(tempNormal)
        }

        let newPoints = []
        let newNormals = []

        for (let i = 0; i < vertexUnfiltered.length; i++)
        {
            let tempVertex = vertexUnfiltered[i].clone()
            let tempNormal = normalsUnfiltered[i].clone()
                
            let isIncluded = false
            for (let x = 0; x < newPoints.length; x++)
            {
                let checkX = tempVertex.x == newPoints[x].x
                let checkY = tempVertex.y == newPoints[x].y
                let checkZ = tempVertex.z == newPoints[x].z

                if (checkX && checkY && checkZ)
                {
                    isIncluded = true
                    x = newPoints.length
                }
            }
            if (!isIncluded)
            {
                newPoints.push(tempVertex)
                newNormals.push(tempNormal)
            }
        }

        this.numberOfElements = newPoints.length > this.numberOfElements ? newPoints.length : this.numberOfElements

        let newGroup = 
        {
            mesh: newMesh,
            points: newPoints,
            normals: newNormals
        }

        this.items[name] = newGroup

        return newGroup
    }

    sortArray(array, mode = 0)
    {
        let newArray = []

        for (let i = array.length - 1; i >= 0; i--)
        {
            let index = i
            let current
            if (mode == 0) current = array[i].x
            else if (mode == 1) current = array[i].y
            else if (mode == 2) current = array[i].z

            for (let x = array.length - 1; x >= 0 ; x--)
            {
                if (mode == 0)
                {
                    if (array[x].x < current)
                    {
                        current = array[x].x
                        index = x
                    }
                }
                else if (mode == 1)
                {
                    if (array[x].y < current)
                    {
                        current = array[x].y
                        index = x
                    }
                }
                else if (mode == 2)
                {
                    if (array[x].z < current)
                    {
                        current = array[x].z
                        index = x
                    }
                }
            }

            newArray.push(array[index])
            array.splice(index, 1)
        }

        return newArray
    }
}